var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"progressBar",staticClass:"progress-bar-content"},[(_vm.showIcon)?_c('span',[_c('BaseIcon',{staticClass:"flash",attrs:{"icon-file":"flash"}})],1):_vm._e(),_c('div',{staticClass:"progress-bar-bg"},[_c('div',{staticClass:"progress-start",class:_vm.percentage === 0 ? 'right-border-radius' : '',style:({
        width: 0
      })}),_c('div',{ref:"progressBarProgress",staticClass:"progress left-border-radius",style:({
        width: _vm.percentage + '%'
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }